<template>
  <div id="mainStage">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
